import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-archive-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-capsule-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-bubble-chart-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCategoryOpen, setMobileCategoryOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <Link
            to="/"
            className="text-foreground-950 font-heading text-xl font-bold tracking-tight whitespace-nowrap cursor-pointer"
          >
            Hipobuy
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <a href="#categories" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Categories
            </a>
            <a href="#about" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              About
            </a>
            <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Guide
            </Link>
            <Link to="/kaspreadsheet-shopping-guide" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Shopping
            </Link>
            <Link to="/kaspreadsheet-product-research" className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer">
              Research
            </Link>

            <div className="relative group">
              <button className="flex items-center gap-1 bg-background-100 border border-background-200 rounded-lg px-4 py-2 text-sm text-foreground-700 cursor-pointer focus:outline-none hover:border-foreground-300 transition-colors whitespace-nowrap">
                Categories
                <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
              </button>
              <div className="absolute top-full right-0 mt-2 w-56 bg-background-50 rounded-xl border border-background-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 py-2 max-h-80 overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-6 h-6 flex items-center justify-center rounded bg-background-100 text-foreground-400 flex-shrink-0">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer relative"
            onClick={() => {
              setMobileMenuOpen(!mobileMenuOpen);
              setMobileCategoryOpen(false);
            }}
            aria-label="Toggle menu"
          >
            <i className={`text-xl text-foreground-950 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 fade-in">
          <div className="px-4 py-4 space-y-1">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 w-full px-4 py-3.5 rounded-xl bg-foreground-950 text-background-50 font-semibold text-sm cursor-pointer mb-3"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-shopping-bag-line w-5 h-5 flex items-center justify-center"></i>
              hipobuy sheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center ml-auto"></i>
            </a>

            <Link
              to="/"
              className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-home-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
              Home
            </Link>

            <button
              onClick={() => setMobileCategoryOpen(!mobileCategoryOpen)}
              className="flex items-center justify-between w-full px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
            >
              <span className="flex items-center gap-3">
                <i className="ri-price-tag-3-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
                Shop Categories
              </span>
              <i className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 transition-transform ${mobileCategoryOpen ? 'rotate-180' : ''}`}></i>
            </button>

            {mobileCategoryOpen && (
              <div className="pl-3 pr-1 space-y-0.5 fade-in max-h-[50vh] overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setMobileCategoryOpen(false);
                    }}
                  >
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-background-100 text-foreground-400 flex-shrink-0">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <span>{cat.name}</span>
                    <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-foreground-300 ml-auto text-xs"></i>
                  </a>
                ))}
              </div>
            )}

            <div className="h-px bg-background-200 mx-4 my-2"></div>

            <Link
              to="/hipobuy-spreadsheet-guide"
              className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-book-open-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
              Beginner Guide
            </Link>

            <Link
              to="/kaspreadsheet-shopping-guide"
              className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-shopping-cart-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
              Shopping Guide
            </Link>

            <Link
              to="/kaspreadsheet-product-research"
              className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-search-eye-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
              Research Tips
            </Link>

            <Link
              to="/kaspreadsheet-vs-traditional"
              className="flex items-center gap-3 px-4 py-3 rounded-xl text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer text-sm"
              onClick={() => setMobileMenuOpen(false)}
            >
              <i className="ri-scales-3-line w-5 h-5 flex items-center justify-center text-foreground-400"></i>
              Comparison
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}